<template>
  <el-form :model="form" ref="form">
    <p>Descreva todas as atividades a serem exercidas pela Empresa. Havendo mais de uma atividade, ordene-as de acordo com a ordem de atuação, iniciando com a atividade principal.</p>

    <draggable v-model="form.atividades">
      <transition-group>
        <div v-for="(atividade, index) in form.atividades" :key="atividade + '_' + index">

          <h3>
            <i class="el-icon-d-caret" v-if="form.atividades.length > 1" style="cursor: pointer;"></i> 
            Atividade {{ index+1 }}
            <el-button type="danger" @click.prevent="removerAtividade(atividade)" icon="delete" v-if="form.atividades.length > 1">Deletar</el-button>
          </h3>

          <el-form-item label="Nome" :prop="'atividades.' + index + '.nome'" :rules="{ required: true, message: 'O nome da atividade é obrigatória', trigger: 'blur'}">
            <el-input v-model="atividade.nome"></el-input>
          </el-form-item>

          <el-form-item label="Descrição" :prop="'atividades.' + index + '.descricao'" :rules="{ required: true, message: 'A descrição da atividade é obrigatória', trigger: 'blur'}">
            <el-input v-model="atividade.descricao"></el-input>
          </el-form-item>

        </div>
      </transition-group>
    </draggable>

    <el-form-item>
      <el-button type="success" @click="adicionarAtividade">Adicionar Atividade</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  props: ['form'],

  components: {
    Draggable
  },

  methods: {
    removerAtividade (item) {
      const index = this.form.atividades.indexOf(item)

      if (item !== -1) {
        this.form.atividades.splice(index, 1)
      }
    },

    adicionarAtividade () {
      this.form.atividades.push({
        key: Date.now(),
        nome: '',
        descricao: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// AtividadesSerExercida.vue?95a554ca